import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getTimeSlot = createAsyncThunk('/GetTimeSlot', async () => {
  const response = await axios.get(`/GetTimeSlot`);
  return response.data;
});
export const getServiceCapacity = createAsyncThunk('/GetServiceCapacity', async (ServiceShopId) => {
  const response = await axios.get(`/GetServiceCapacity/${ServiceShopId}`);
  return response.data;
});
export const getTechnicianCapacity = createAsyncThunk('/GetTechnicianCapacity', async (EmployeeId) => {
  const response = await axios.get(`/getTechnicianCapacity/${EmployeeId}`);
  return response.data;
});

const serviceCapacitySlice = createSlice({
  name: 'serviceCapacity',
  initialState: {
    loading: false,
    error: '',
    TimeSlot: [],
    ServiceCapacity: [],
    IsChecked: true,
    TechnicianCapacity: []
  },
  reducers: {
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },
  extraReducers: {
    [getTimeSlot.pending]: (state) => {
      state.loading = true;
    },
    [getTimeSlot.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTimeSlot.fulfilled]: (state, action) => {
      state.TimeSlot = action.payload;
      state.loading = false;
    },
    [getServiceCapacity.pending]: (state) => {
      state.loading = true;
    },
    [getServiceCapacity.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceCapacity.fulfilled]: (state, action) => {
      state.ServiceCapacity = action.payload;
      state.loading = false;
    },
    [getTechnicianCapacity.pending]: (state) => {
      state.loading = true;
    },
    [getTechnicianCapacity.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnicianCapacity.fulfilled]: (state, action) => {
      state.TechnicianCapacity = action.payload;
      state.loading = false;
    }
  }
});

export const serviceCapacityActions = serviceCapacitySlice.actions;
export default serviceCapacitySlice;
